import React, { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { GoChevronDown } from "react-icons/go";
import { useOpenCloseMenu } from "../../hooks/useOpenCloseMenu";
import ButtonFullWidth from "../Buttons/ButtonFullWidth";
import { Language } from "./Languages";

function LanguageSwitch(
  props: Readonly<{
    setIsAllMenuOpen: Dispatch<SetStateAction<boolean>>;
    isAllMenuOpen: boolean;
    isInline: boolean;
    languages?: Language[];
  }>
) {
  const [t, i18n] = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };
  const [isMouseOut, setIsMouseOut] = useState(false);
  const [isCurrentMenuOpen, setIsCurrentMenuOpen] = useState(false);

  useOpenCloseMenu({ isMouseOut, setIsCurrentMenuOpen });

  return (
    <div
      className="text-sm md:text-md w-full"
      onMouseEnter={() => {
        setIsMouseOut(false);
        props.setIsAllMenuOpen(true);
        setIsCurrentMenuOpen(true);
      }}
      onMouseLeave={() => {
        setIsMouseOut(true);
      }}
      role="none"
    >
      <button
        onClick={() => {
          setIsMouseOut(false);
          setIsCurrentMenuOpen(!isCurrentMenuOpen);
        }}
        className="w-full"
      >
        <div
          className={
            props.isInline
              ? " flex items-center md:pt-[8px] md:pb-[8px] pl-[7px] pr-[5px] rounded-md  hover:bg-lightbg-150 "
              : "w-full flex items-center pt-[4px] pb-[4px] md:pt-[8px] md:pb-[8px] pl-[20px]  rounded-md hover:bg-lightbg-150 "
          }
        >
          {language} <GoChevronDown />
        </div>
      </button>
      <div className="relative ">
        {isCurrentMenuOpen && (
          <div
            className={
              "flex flex-col items-start  rounded-md  pt-[5px] pb-[5px] w-[100px] md:w-[208px] pl-[5px] pr-[5px]  absolute right-[100%] shadow-2xl         border-lightbg-100 border-solid border-[1px]     bg-lightbg-200 "
            }
          >
            {props.languages?.map((language) => {
              return (
                <ButtonFullWidth
                  key={language.Name}
                  onClick={() => {
                    props.setIsAllMenuOpen(false);
                    setIsCurrentMenuOpen(false);
                    setLanguage(language.Value);
                    changeLanguage(language.Value);
                  }}
                >
                  {language.Name}
                </ButtonFullWidth>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default LanguageSwitch;
